export const createFilterSection = (options, fixedValues) => {
    const filteredOptions = fixedValues ? options.filter(option => !fixedValues.includes(option.value)) : options;
    return { options: filteredOptions, fixed: fixedValues || [] };
};
